import BaseHttp from '../../../plugins/baseHttp';
import dayjs from 'dayjs';

const get = () => {
  const today = dayjs().toISOString();
  const yesterday = dayjs().subtract(1, 'day',).toISOString();

  return BaseHttp.get(`/logistic/orders?created_at>=${yesterday}&created_at<=${today}&fields=code,store,created_at,stage,delivery_form.price,tracking_info.tracking_status,tracking_info.task_id`,);
};

const getOrderHistory = ({ begin_date, end_date, },) => BaseHttp.get(`/logistic/orders?created_at>=${begin_date}&created_at<=${end_date}&fields=code,store,created_at,stage,delivery_form.price,tracking_info.tracking_status,tracking_info.task_id`,);

const getOrdersIndicators = ({ begin_date, end_date, },) => BaseHttp.get(`/logistic/orders/summary?created_at>=${begin_date}&created_at<=${end_date}`,);

const handleError = (error,) => {
  return BaseHttp.handleError(error,);
};

export default {
  get,
  getOrderHistory,
  getOrdersIndicators,
  handleError,
};
